// extracted by mini-css-extract-plugin
export default {"card":"Card_card__48SLx","hoverable":"Card_hoverable__80bXJ"};